import { CartonProduct } from './product.types';
import { PropertyOption } from './shared';
import { PublicUser, ShippingMethod } from './user.types';

export interface OfferPropertyOption extends PropertyOption {
    default: boolean;
    hint?: string | null;
}

export type OfferDraftSource = 'manual' | 'import';

export interface OfferPhoto {
    id: number;
    filename: string;
    thumbnail_url: string;
    url: string;
}

export interface OfferPhotoUpload {
    [key: string]: string;
    signed_id: string;
    filename: string;
    preview_url: string;
}

export interface OfferDraft {
    draft_id: string;
    product_id: string;
    price: string;
    amount: string;
    property_set: Record<string, string>;
    photo_blob_ids?: string[];
    photos: OfferPhotoUpload[];
    product: CartonProduct | null;
    universe_id?: number | null;
    product_type_id?: number | null;
    source?: OfferDraftSource | null;
    source_code?: string | null;
    import_name?: string | null;
    import_error?: string | null;
    scryfall_id?: string | null;
    auto_price_status?:
        | 'priced'
        | 'pending'
        | 'loading'
        | 'error'
        | 'unavailable'
        | 'manual'
        | null;
    auto_price_error?: string | null;
    auto_price_source?: string | null;
    auto_price_base?: string | null;
}

export interface Offer {
    id: number;
    amount: number;
    premium_active: boolean;
    premium_until: string | null;
    seller_id: number;
    product: CartonProduct;
    seller_name: string;
    seller_shipping_methods: ShippingMethod[];
    seller_paused: boolean;
    seller_paused_until: string | null;
    price: number;
    property_set: Record<string, string>;
    photos: OfferPhoto[];
    status: 'active' | 'inactive' | 'cancelled';
    views_count: number;
    // todo: rename to User
    user: PublicUser;
    seller_completed_orders_count: number;
}

export interface CardmarketPricePoint {
    key: 'trend' | 'avg7' | 'avg30' | 'avg';
    label: string;
    cents: number;
    amount: string;
    currency: string;
    uah: number | null;
}

export interface OfferPriceAnalysisRow extends Offer {
    cardmarket_prices: CardmarketPricePoint[];
    reference_price: CardmarketPricePoint | null;
    deviation_percent: number | null;
    deviation_amount_uah: number | null;
    price_date: string | null;
}

export interface OfferPriceAnalysisSummary {
    total: number;
    below_market: number;
    above_market: number;
    without_market_price: number;
    average_deviation_percent: number | null;
}

export interface OfferProperty {
    id: number;
    name: string;
    slug: string;
    kind: string;
    position: number;
    required: boolean;
    hint?: string | null;
    filterable: boolean;
    searchable: boolean;
    multiselect: boolean;
    filter_control:
        | 'select'
        | 'multi_select'
        | 'icon_multi_select'
        | 'toggle'
        | 'number_range';
    filter_position?: number | null;
    filter_settings: Record<string, unknown>;
    product_type_id: number;
    offer_property_options: OfferPropertyOption[];
}

export type OfferType = 'all' | 'active' | 'inactive';

export enum OfferActionTypes {
    Activate = 'activate',
    Deactivate = 'deactivate',
    Delete = 'delete',
}

export enum OfferActionQuantity {
    Single = 'single',
    Bulk = 'bulk',
}

export type OfferActionPayload =
    | {
          type: OfferActionTypes;
          quantity: OfferActionQuantity.Single;
          offerId: number;
      }
    | {
          type: OfferActionTypes;
          quantity: OfferActionQuantity.Bulk;
          offersId: number[];
      };

export interface DuplicateWarning {
    message: string;
    edit_url?: string;
}
